import { useParams } from "react-router-dom";

import BucketAddList from "./List.jsx";
import BucketAddDetail from "./Detail.jsx";

const BucketsAddPage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? BucketAddDetail : BucketAddList;

    return <Specified />;
};

export default BucketsAddPage;
